import SearchProduct from './SearchProduct.js';
export default SearchProduct;
